import { CSSProperties } from 'react';

import {
  PREVIEW_CONTAINER_HEIGHT,
  PREVIEW_CONTAINER_WIDTH
} from 'views/OfferDesign/OfferDesign.consts';
import {
  OfferDesignTypes,
  RenderCardFn
} from 'views/OfferDesign/OfferDesign.types';

import {
  renderBundleCard,
  renderPopupCard,
  renderProgressBarCard,
  renderProgressBarCardV2,
  renderPromotionCard,
  renderRollingOfferCard,
  renderTriggeredPopupCard
} from './OfferDesignPreview.utils';

export const PREVIEW_ELEMENT_ID = 'offer-design-preview';

interface RenderMapOptions {
  isProgressBarV2?: boolean;
}

export const getRenderMap = ({
  isProgressBarV2
}: RenderMapOptions = {}): Record<string, RenderCardFn> => ({
  [OfferDesignTypes.Bundle]: renderBundleCard,
  [OfferDesignTypes.SpecialOffer]: renderPromotionCard,
  [OfferDesignTypes.ProgressBar]: isProgressBarV2
    ? renderProgressBarCardV2
    : renderProgressBarCard,
  [OfferDesignTypes.RollingOffer]: renderRollingOfferCard,
  [OfferDesignTypes.PopUp]: renderPopupCard,
  [OfferDesignTypes.TriggeredPopup]: renderTriggeredPopupCard
});

export const BASE_CONTAINER_STYLE: CSSProperties = {
  width: PREVIEW_CONTAINER_WIDTH,
  position: 'relative'
};

export const ROLLING_OFFER_CONTAINER_STYLE: CSSProperties = {
  ...BASE_CONTAINER_STYLE,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  overflow: 'hidden'
};

export const POPUP_CONTAINER_STYLE: CSSProperties = {
  ...BASE_CONTAINER_STYLE,
  minHeight: PREVIEW_CONTAINER_HEIGHT,
  overflow: 'hidden',
  transform: 'translateZ(0)'
};

export const CONTAINER_STYLE_MAP: Record<string, CSSProperties> = {
  [OfferDesignTypes.PopUp]: POPUP_CONTAINER_STYLE,
  [OfferDesignTypes.TriggeredPopup]: POPUP_CONTAINER_STYLE,
  [OfferDesignTypes.RollingOffer]: ROLLING_OFFER_CONTAINER_STYLE
};
